module.exports = __webpack_public_path__ + "img/img-download-shipping-label.6969d567.png";